import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

type TabsContextType<T extends string> = {
  selectValue: T
  onTabChange: (value: T) => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabsContext = createContext<TabsContextType<any> | null>(null)

export const useTabsContext = <T extends string>(): TabsContextType<T> => {
  const context = useContext(TabsContext)

  if (context === null) {
    throw new Error('useTabsContext must be used within a TabsContextProvider')
  }

  return context
}

export const TabsProvider = <T extends string>({ children, value }: PropsWithChildren & { value: TabsContextType<T> }) => {
  return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>
}
